import {loadable} from "jotai/utils";
import {atomWithRefresh} from "../utils/jotaiUtils";
import {Company} from "../types/domain/company";
import {getCompanyById} from "../services/companyService";
import {DEMO_COMPANY_ID} from "../utils/constants";

export const demoCompanyAtom = atomWithRefresh<Promise<Company>>(async () => {
    return getCompanyById(DEMO_COMPANY_ID);
});

export const demoCompanyLoadable = loadable(demoCompanyAtom);
